export default "__VITE_ASSET__CwrG8M9L__"